<template>
  <div class="wangzhan" style="padding-top: 50px;  overflow: hidden;">
    <img src="../../static/image/wangzhan_title.png" class="fullWidth" />
    <div style="height: 100px;"></div>
    <div class="ui-title">网站建设</div>
    <div style="height: 30px;"></div>
    <div class="font14 color99 fontfaYahei alignCenter">将策略和执行紧密结合，不断评估优化我们的网站设计方案</div>
    <div style="height: 50px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col offset="1">
        <div class="andr">
          <p>网站建设</p>
          <p>我们的网站建设整合解决方案结合了简云互联网品牌建设经验和整合营销的理念，并将策略执行紧密结合，不断评估优化我们的网站设计方案，为客户提供一体化的互联网品牌整合方案！</p>
          <p>开发流程</p>
          <p>01.用户需求分析</p>
          <p>02.分析策划</p>
          <p>03.合同签订</p>
          <p>04.页面设计</p>
          <p>05.开发制造</p>
          <p>06.上线测试</p>
          <p>07.反馈修改</p>
          <p>08.开通上线</p>
          <p>09.全年维护</p>
        </div>
        <img src="../../static/image/wangzhan_contente.png" class="fullWidth iosimg" />
      </Col>
    </Row>
    <div style="height: 100px;"></div>
    <div style="position: relative">
      <img
        src="../../static/image/wangzhan_dingzhi_back.png"
        class="fullWidth"
        style="height:700px"
      />
      <Row
        type="flex"
        justify="center"
        class="code-row-bg"
        style="position: absolute;left: 0;right: 0;top: 0;bottom:0;z-index: 99"
      >
        <Col span="18">
          <div style="position: absolute;left: 0;right: 130px;top: 40px;">
            <div class="fontfaYahei font36 color33 alignCenter">定制</div>
            <div class="fontfaYahei font14 color99 alignCenter">
              在意每一丝细节
              <br />创新不是要改变世界，而是不再重复昨天
            </div>
          </div>
          <table class="fullWidth" style="height: 100%;">
            <tr>
              <td style="padding-top:30px;">
                <div class="wangzhan-title">策略</div>
                <div class="wangzhan-subtitle" style="margin-bottom: 30px;">
                  好网站不是拍脑袋一蹴而成也不是空洞无物的摆设。从网站定位、信息架构、原型规划到设计方向、
                  内容的传播梳理、包括网站功能的探讨和合理表现。
                  我们整体把控、保证有序、有料、有品质、有传播的方向，形成真正具有高端品牌感的网站呈现体系。
                </div>
                <div class="wangzhan-title">技术</div>
                <div class="wangzhan-subtitle" style="margin-bottom: 30px;">
                  对互联网技术的实时把握，保障了我们技术始终领先，为您网站稳定快速高效的运行提供全面的技
                  术支持，协助企业创建完备出色的互联网信息平台。
                  利用现代科技手段把握机遇，并创造更高价值，成功迈向国际商务领域。
                </div>
                <div class="wangzhan-title">创意</div>
                <div class="wangzhan-subtitle">
                  网络体验上的创意 / 设计方向创意 / 动效执行创意功能架构创意/技术优化创意
                  创意，无处不在。是你的网站亮点所在。
                  从主体网站设计风格html方式的最新运用js网络创意搭配联创互联不断创新，提供有活力的国际化网站构建。
                </div>
              </td>
              <!-- <td width="30%" valign="top"> -->
              <img
                src="../../static/image/wangzhan_dingzhi_img.png"
                class="fullWidth imgser"
                style="margin-left:20%"
              />
              <!-- </td> -->
            </tr>
          </table>
        </Col>
      </Row>
    </div>
    <div style="height: 50px;"></div>
    <div style="height: 50px;"></div>
    <div
      class="alignCenter"
      style="font-family: 'Microsoft YaHei';font-size: 36px;color: #333333;"
    >服务项目</div>
    <div style="height: 30px;"></div>
    <div
      class="alignCenter"
      style="font-family: 'Microsoft YaHei';font-size: 16px;color: #999999"
    >百分百定制开发，一对一的专业设计，全程项目跟踪，简云用专业和态度为您提供优质的服务。</div>
    <div style="height: 30px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <Row>
          <Col
            span="6"
            style=" height: 350px;border-radius: 8px;"
            class="haoshi curP"
            v-for="(item,index) in youshiList"
            :key="index"
          >
            <div style="height: 175px;">
              <div class="BTjuzhongP">
                <div class="BTjuzhongC">
                  <img :src="item.imgs" style="width: 20%;" class="centerLR" />
                  <div
                    class="alignCenters"
                    style="font-family: 'Microsoft YaHei';font-size:14px;color: #333333;padding-top: 20px; "
                  >{{item.name}}</div>
                </div>
              </div>
            </div>
            <div style="height: 1px;background:#f5f5f5;margin: 0 20px;"></div>
            <div
              style="width:200px; margin:0 auto; height: 174px;font-family: 'Microsoft YaHei';font-size: 14px;color: #999999;word-wrap:break-word;"
            >{{item.subname}}</div>
          </Col>
        </Row>
      </Col>
    </Row>
    <div style="height:100px;"></div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }
export default {
  name: "wangzhan",
  data() {
    return {
      youshiList: [
        {
          name: "分析策划",
          imgs: img_url_i + "/static/image/wang1.png",
          subname: "结合品牌理念及品牌诉求,编撰策划分析提案。"
        },
        {
          name: "页面设计",
          imgs: img_url_i + "/static/image/wang2.png",
          subname: "依据行业特点定制设计100%,贴合设计。"
        },
        {
          name: "前端制作",
          imgs: img_url_i + "/static/image/wang3.png",
          subname: "采用HTML5将效果图制作成,静态页面。"
        },
        {
          name: "SEO配置",
          imgs: img_url_i + "/static/image/wang4.png",
          subname: "遵循搜索引擎技术标准,全站静态化。"
        },
        {
          name: "网站域名",
          imgs: img_url_i + "/static/image/wang5.png",
          subname: "国际顶级或者国家顶级域名,全球无障碍互联互通。"
        },
        {
          name: "网络主机",
          imgs: img_url_i + "/static/image/wang6.png",
          subname: "2型阿里云BGP多线云主机,配置独立IP地址。"
        },
        {
          name: "兼容标准",
          imgs: img_url_i + "/static/image/wang7.png",
          subname: "不同操作系统、不同浏览器、不同浏览终端实现零像素差异。"
        },
        {
          name: "采用技术",
          imgs: img_url_i + "/static/image/wang8.png",
          subname: "PHP+MySQL+HTML5+CSS+JavaScript。"
        }
      ]
    };
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.colorter {
  position: absolute;
  top: -40px;
  left: 30px;
}
.cehuas {
  position: absolute;
  left: 30px;
  top: 100px;
}
.wangzhan-subtitle {
  width: 570px;
  height: 63px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.imgser {
  width: 379px;
  height: 499px;
}
@media (min-width: 1090px) {
  .andr {
    border: 1px solid #dedddd;
    width: 500px;
    height: 600px;
    top: 7%;
    left: -10%;
    background: rgba(255, 255, 255, 1);
    position: absolute;
  }
  p {
    margin: 0px 30px;
  }
  p:nth-child(1) {
    margin-top: 12%;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 5px;
  }
  p:nth-child(2) {
    height: 17%;
    margin-top: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
  }
  p:nth-child(3) {
    margin-top: 5%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 26px;
  }
  p:nth-child(4) {
    margin-top: 5%;
  }
  p:nth-child(12) {
    margin-bottom: 20%;
  }
  p {
    height: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
  }
  .iosimg {
    width: 1046px;
    height: 698px;
  }
  .centerLR {
    padding-top: 70px;
  }
}
@media (max-width: 1090px) {
  .andr {
    border: 1px solid #dedddd;
    width: 400px;
    height: 520px;
    top: 7%;
    left: -10%;
    background: rgba(255, 255, 255, 1);
    position: absolute;
  }
  p {
    margin: 0px 30px;
  }
  p:nth-child(1) {
    margin-top: 12%;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  p:nth-child(2) {
    height: 17%;
    margin-top: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
  }
  p:nth-child(3) {
    margin-top: 5%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 26px;
  }
  p:nth-child(4) {
    margin-top: 5%;
  }
  p:nth-child(12) {
    margin-bottom: 20%;
  }
  p {
    height: 5%;
    font-size: 14px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
  }
  .iosimg {
    width: 900px;
    height: 600px;
  }
  .centerLR {
    padding-top: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wangzhan.vue